import React from 'react';
import './table.scss';
import Header from './Header';
import Body from './Body';

const Table = ({
  columns,
  data,
  className,
  pagination,
  pageSize,
  pageNumer,
  onPageChange,
  liveData,
  headerClass,
  footerClass,
}) => (
  <table className={`table mb-0 ${className || ''}`}>
    <Header columns={columns} className={headerClass} />
    <Body columns={columns} data={data} />
  </table>
);

export default Table;
